module.exports = __webpack_public_path__ + "img/logo.cc6ca4ed.svg";